import { SET_ROLE, SET_ROLES } from "../../constants/roleConstants";

export const setRole = (role) => {
  return {
    type: SET_ROLE,
    role,
  };
};

export const setRoles = (roles, filtered = false) => {
  return {
    type: SET_ROLES,
    roles,
    filtered,
  };
};
